<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="report-base-filter"
          style="min-width: 200px"
        ></select-project>

        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="report-base-filter"
          style="min-width: 200px"
        ></v-select>
        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 150px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 150px"
        />

        <v-btn color="info" v-on:click="search" class="mt-2" :disabled="loading" :loading="loading">Search</v-btn>
        <export :fields="exportFields" :data="filteredItems" />
      </v-row>
      <v-row class="mx-2">
        <v-text-field
          v-model="rule"
          placeholder="(deposit - withdraw - bonus) * 0.1"
          hint="Should contains only 0-9, +, -, *, /, deposit, withdraw, bonus, bonus_withdraw, release_bonus, default: (deposit - withdraw - bonus) * 0.1"
          persistent-hint
          class="mt-0 pt-0 mb-0 pb-0"
        ></v-text-field>
      </v-row>
    </v-card>


    <v-card class="col-12 pt-4 pb-4 px-0 mt-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        sort-by="created"
        sort-desc
        :height="`calc(100vh - 165px - 55px - ${!options.pagination && filteredItems.length < 1000 ? 0 : 40}px - ${!options.padding ? 0 : options.padding}px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        fixed-header
        calculate-widths
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :hide-default-footer="!options.pagination && filteredItems.length < 1000"
        :items-per-page="options.perpage || (!options.perpage && filteredItems.length > 1000 ? 1000 : null) || -1"
        :footer-props="{'items-per-page-options': options.perpage ? ( options.perpage_list || [30, 60, 90]) : [(filteredItems.length > 1000 ? 1000 : null) || -1]}"
        :class="{nowrap, 'table-size-fixed': table_size_fixed, 'report-dt': true}"
        style="z-index: 0; position: relative; width: 100%"
      >
        <template v-slot:item.row_num="{ index }">
          <span>{{ index + 1 }}</span>
        </template>
        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank" v-if="!item.total">{{ (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), '')) }}</a>
          <div v-if="item.total">Total:</div>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <a :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank" v-if="!item.total">{{ item.account_id }}</a>
        </template>
        <template v-slot:item.duplicates="{ item, header }">
          <span style="zoom: 0.8" v-html="duplicatesFlags(item.duplicates)"></span>
        </template>
        <template v-slot:item.doubles="{ item, header }">
          <span style="zoom: 0.8" v-html="duplicatesFlags(item.doubles)"></span>
        </template>
        <template v-slot:item.comment="{ item, header }">
          <div :style=" !header.style ? {'min-width': '250px', 'white-space': 'normal'} : header.style" v-html="$sanitize(item.comment)"></div>
        </template>
        <template v-slot:item.comment="{ item }">
          <template v-if="item.comment.length <= 25">{{ item.comment }}</template>
          <div v-else style="min-width: 150px;max-width: 250px; white-space: normal;">{{ item.comment }}</div>
        </template>

        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';
</style>

<script>
  import moment from 'moment'
  import { find, get, map, filter } from 'lodash'
  import { API } from '@/utils/api'
  import { duplicatesFlags } from '@/utils/helper'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    name: 'CashbackCalc',
    props: { title: {}, headers: {}, filters: {}, url: {}, defaultParams: { default: () => ({}) }, nowrap: { default: true }, table_size_fixed: { default: false }, options: { default: () => ({}) } },

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },

    data: () => ({
      totalItems: -1,
      tableOptions: {},
      project: null,
      loading: false,
      totalRow: false,
      totalRows: false,
      items: [],
      rule: '(deposit - withdraw - bonus) * 0.1',
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      dateRangeList,
      accountType: [ 'casino', 'sport' ]
    }),

    computed: {

      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data

                return eval(d[f].toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes(d[f])
                || (d[f].toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0)
          })
        })
      },
      filteredTotalRows: function () {
        return this.totalRows.filter(d => {
          return Object.keys(this.filters).every(f => {
            if (f != 'currency') {
              return true
            }
            return (this.filters[f].data.length < 1 || (this.filters[f].data.includes(d[f]) || (d[f].toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    watch: {
      tableOptions: {
        handler () {
          if (this.options.pagination) {
            this.search()
          }
        },
        deep: true,
      },
    },

    methods: {
      duplicatesFlags,

      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      getTotalHeaderText: function (alias) {
        return find(this.headers, (o) => o.value === alias, {}).text
      },

      search: function () {
        this.loading = true
        try {
          if (this.options.accountType) {
            this.defaultParams.account_type = this.accountType
          }

          API.call(this.url, {
            from: this.from,
            to: this.to,
            rule: this.rule,
            ...this.defaultParams,
            ...this.tableOptions
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])
            if (get(resp, 'pagination', false)) {
              this.totalItems = resp.pagination.total
            }
            if (get(resp, 'totalRow', false)) {
              this.totalRow = resp.totalRow
            }
            if (get(resp, 'totalRows', false)) {
              this.totalRows = resp.totalRows
            }

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return this.items.map(d => d[val])
      }
    },
  }
</script>
